<template>
  <div class="row">
    <div class="col-lg-8 col-sm-12">
      <select-equipe-profissional
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :callbackOnChangeProfissional="onChangeProfissional"
        :activeOptionTodos="false"
        :flexSize="2"
      >
      </select-equipe-profissional>
    </div>
    <div class="col-lg-4 col-sm-12">
      <vue-select
        v-model="tipoDoenca"
        :options="doencas"
        label="label"
        placeholder="Comorbidades"
        @input="onChangeDoenca"
        class="select-comorbidades"
        :disabled="disabledSelectDoenca"
      >
        <div slot="no-options">Não há opções correspondentes</div>
      </vue-select>
    </div>
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item"></div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="condicoes-saude"
          >
          </download-files>
        </div>
      </div>
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        :ultimaAtualizacao="ultimaAtualizacao"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import SelectEquipeProfissional from '@/components/utils/SelectEquipeProfissional.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { dataFields } from './utils.js'
export default {
  name: 'ComorbidadesPorEquipeAcs',
  components: {
    TabelaCadastros,
    SelectEquipeProfissional,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipe: '',
      profissionais: [],
      profissional: '',
      dados: [],
      cadastros: [],
      page: 1,
      perPage: 10,
      pages: [],
      nome: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      nomeEquipe: '',
      nomeProfissional: '',
      doencas: Functions.doencas,
      tipoDoenca: '',
      cadastrosOriginais: [],
      filterSearchTable: false,
      dataFields: {
        ...dataFields,
      },
      disabledSelectDoenca: true,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    async filtros(tipoDoenca) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais

      if (this.profissional !== '') {
        await this.buscarDados()
        data = this.cadastros
      }

      if (tipoDoenca === null) {
        this.tipoDoenca = ''
        tipoDoenca = ''
      }
      if (tipoDoenca !== '') {
        data = this.filtroDoenca(data, tipoDoenca)
      }

      this.cadastros = data
      this.total_de_registros_da_tabela = this.cadastros.length
      this.cadastrosPdf = this.cadastros
      this.disabledSelectDoenca = false
    },
    async onChangeDoenca(event) {
      this.filtros(event)
    },
    filtroDoenca(items, event) {
      const comorbidadeSelecionada = event.label

      if (comorbidadeSelecionada === 'Todas') {
        return items
      } else if (comorbidadeSelecionada === 'Sem comorbirdade') {
        return items.filter((item) => {
          return (
            item.comorbidades.length === 1 &&
            item.comorbidades[0].label === 'Sem comorbidades'
          )
        })
      } else if (comorbidadeSelecionada === 'Com alguma comorbidade') {
        return items.filter((item) => {
          return (
            item.comorbidades.length > 0 &&
            item.comorbidades[0].label !== 'Sem comorbidades'
          )
        })
      } else if (comorbidadeSelecionada === 'Hipertensos e diabéticos') {
        return items.filter((item) => {
          return item.comorbidades.some((comorbidade) => {
            return comorbidade.label === 'Hipertensão e diabetes'
          })
        })
      } else {
        return items.filter((item) => {
          return item.comorbidades.some(
            (comorbidade) => comorbidade.label === comorbidadeSelecionada
          )
        })
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.equipe = event
        this.nomeEquipe = event.no_equipe
        this.profissional = ''
        this.profissionais = []
        this.nomeProfissional = ''
        this.tipoDoenca = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.disabledSelectDoenca = true
        try {
          this.loading = true

          const response = await Functions.getCadastrosPorEquipe(
            this.cod_ibge,
            this.equipe.nu_ine
          )
          const responseTratadaParaVirComComorbidades =
            Functions.getComobidades(response)

          this.cadastrosOriginais = responseTratadaParaVirComComorbidades
          this.cadastros = responseTratadaParaVirComComorbidades
          this.disabledSelectDoenca = false
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      } else {
        this.nomeEquipe = ''
        this.profissional = ''
        this.profissionais = []
        this.nomeProfissional = ''
        this.tipoDoenca = ''
        this.cadastros = []
        this.cadastrosOriginais = []
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.disabledSelectDoenca = true
      if (event !== null) {
        this.profissional = event
        this.nomeProfissional = event.no_profissional
        this.tipoDoenca = ''
        this.filtros(null)
      } else {
        this.tipoDoenca = ''
        this.profissional = ''
        this.nomeProfissional = ''
        this.filtros(null)
      }
    },

    // busca os dados de acordo com os valores do select
    async buscarDados() {
      try {
        this.loading = true
        const response = await Functions.getCadastros(
          this.cod_ibge,
          this.profissional.nu_cpf
        )
        const responseTratadaParaVirComComorbidades =
          await Functions.getComobidades(response)

        this.cadastros = responseTratadaParaVirComComorbidades
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.nomeProfissional
      )
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
    },
  },

  created() {
    this.init()
  },
}
</script>

<style lang="scss">
.select-comorbidades {
  .vs__dropdown-toggle {
    margin-top: 10px;
    height: 45px;
    @media screen and (max-width: 656px) {
      margin-top: 0;
      margin-bottom: 20px;
    }
    @media screen and (min-width: 657px) and (max-width: 807px) {
      margin-top: 0;
      margin-bottom: 20px;
    }

    @media screen and (min-width: 808px) and (max-width: 1023px) {
      margin-top: 0;
      margin-bottom: 20px;
    }

    @media screen and (min-width: 1024px) and (max-width: 1265px) {
    }
  }
}
</style>
